module.exports = __webpack_public_path__ + "static/media/wallstart_tablet.02b1c3fe.jpg";